// variantLogic.js - Ne plus utiliser de hooks ici, passer les valeurs depuis le composant
export const getVariantItems = (isBrowsingAllowedTo, viewAs, rolesLoading) => {
    // Si les privilèges sont en cours de chargement, retourner un tableau vide
    if (rolesLoading) {
        return [];
    }

    // Évaluer une seule fois les autorisations liées à overflow afin d'éviter des résultats incohérents
    // si isBrowsingAllowedTo dépend de cookies/privilèges qui viennent d'être mis à jour.
    const overflowAllowed = isBrowsingAllowedTo("/overflow");
    const overflowSimulationAllowed = isBrowsingAllowedTo("/overflowSimulation");

    const itemsByRole = {
        admin: [
            { name: "navbarAdmin.consultant", path: "/consultant", disabled: !isBrowsingAllowedTo("/consultant") },
            { name: "prospects.prospects", path: "/prospects", disabled: !isBrowsingAllowedTo("/prospects") },
            // TEMPORAIRE : onglet renomme "Candidats". Pour reactiver "Administration", remettre la ligne commentee.
            // { name: "navbarConsultant.administration", path: "/management", disabled: !isBrowsingAllowedTo("/management") },
            { name: "navbarAdmin.candidates", path: "/management", disabled: !isBrowsingAllowedTo("/management") },
            // { name: "navbarAdmin.finance", path: "/finance"  , disabled: !isBrowsingAllowedTo("/finance")},
            // { name: "navbarAdmin.statistics", path: "/statistics"  , disabled: !isBrowsingAllowedTo("/statistics")},
            // { name: "navbarAdmin.overflowOptimization", path: "/overflowManagement", disabled: !isBrowsingAllowedTo("/overflowManagement") },
        ],
        consultant: [
            { name: "navbarConsultant.administration", path: "/administration", disabled: !isBrowsingAllowedTo("/administration") },
            // { name: "navbarConsultant.profitSharing", path: "/profitSharing"  , disabled: !isBrowsingAllowedTo("/profitSharing")},
            // { name: "navbarConsultant.compagnyValuation", path: "/companyValuation"  , disabled: !isBrowsingAllowedTo("/companyValuation")},
            overflowAllowed
                ? { name: "navbarConsultant.overflowOptimization", path: "/overflow", disabled: false }
                : { name: "navbarConsultant.overflowOptimization", path: "/overflowSimulation", disabled: !overflowSimulationAllowed }
        ],
    };

    if (viewAs === 'ADMIN_') return itemsByRole.admin;
    if (viewAs === 'USER_') return itemsByRole.consultant;

    return [];
};
